module.exports = __webpack_public_path__ + "static/media/ic-investment-strategy.34787147.svg";